<div class="plan-annuel" [attr.inert]="rechercheVisible() ? '' : null"
  [attr.aria-hidden]="rechercheVisible() ? 'true' : null">

  <section class="mobile-operations-header" aria-label="Opérations du mois courant">
    <div class="mobile-operations-header__title">
      <div class="mobile-operations-header__heading">
        <h2>Opérations</h2>
        <p>{{ libelleMoisMobile }}</p>
      </div>
      <div class="mobile-operations-header__toolbar" role="group" aria-label="Actions des opérations">
        <button type="button" class="mobile-action mobile-action--icon" (click)="ouvrirCreation.emit()"
          aria-label="Ajouter une opération" title="Ajouter une opération">
          <i class="ph ph-plus" aria-hidden="true"></i>
        </button>
        <button type="button" class="mobile-action mobile-action--icon" (click)="rechercheVisible.set(true)"
          aria-label="Rechercher une opération" title="Rechercher une opération">
          <i class="ph ph-magnifying-glass" aria-hidden="true"></i>
        </button>
        <button type="button" class="mobile-action mobile-action--icon mobile-operations-header__filter"
          [class.mobile-action--active]="!masquerPointeesMobile()"
          [attr.aria-pressed]="!masquerPointeesMobile()"
          [attr.aria-label]="masquerPointeesMobile() ? 'Afficher les opérations pointées' : 'Masquer les opérations pointées'"
          [title]="masquerPointeesMobile() ? 'Afficher les opérations pointées' : 'Masquer les opérations pointées'"
          (click)="masquerPointeesMobile.set(!masquerPointeesMobile())">
          <i class="ph" [ngClass]="masquerPointeesMobile() ? 'ph-eye' : 'ph-eye-slash'" aria-hidden="true"></i>
        </button>
        <button type="button" class="mobile-action mobile-action--icon mobile-action--powens" (click)="importerDepuisPowens()"
          aria-label="Importer Powens" [title]="chargementPowens() ? 'Import en cours…' : 'Importer Powens'"
          [attr.aria-busy]="chargementPowens()"
          [disabled]="chargementPowens() || chargementGestionPowens() || chargementSelectionPowens()">
          <i class="ph-fill" [ngClass]="chargementPowens() ? 'ph-circle-notch icone-charge' : 'ph-bank'" aria-hidden="true"></i>
        </button>
      </div>
    </div>
    @if (erreur()) {
      <p class="plan-annuel__erreur" role="alert">{{ erreur() }}</p>
    }
  </section>

  <!-- En-tête -->
  <div class="plan-annuel__header">
    <div class="plan-annuel__header-left">
      <h2>Plan annuel</h2>
    </div>
    <div class="plan-annuel__nav-annee">
      <button type="button" class="btn-nav" (click)="anneePrecedente()">&#8249;</button>
      <strong class="annee-label">{{ libelleAnnee() }}</strong>
      <button type="button" class="btn-nav" (click)="anneeSuivante()">&#8250;</button>
    </div>
    <div class="plan-annuel__nav-mois">
      <button type="button" class="btn-nav" (click)="moisPrecedent()">&#8249; Mois préc.</button>
    </div>
    <button type="button" class="btn-ajouter" (click)="ouvrirCreation.emit()">+ Nouvelle opération</button>
    <button type="button" class="btn-rechercher" (click)="rechercheVisible.set(true)"
      aria-label="Rechercher une opération" title="Rechercher une opération">
      <i class="ph ph-magnifying-glass" aria-hidden="true"></i>
    </button>
    <button type="button" class="btn-importer" (click)="importerDepuisPressePapier()">&#x2398; Importer</button>
    <button
      type="button"
      class="btn-importer-powens"
      (click)="importerDepuisPowens()"
      [disabled]="chargementPowens() || chargementGestionPowens() || chargementSelectionPowens()"
      aria-label="Importer les opérations depuis Powens"
      title="Importer depuis l’API Powens"
      >
      <i
        class="ph-fill"
        [ngClass]="chargementPowens() ? 'ph-circle-notch icone-charge' : 'ph-bank'"
        aria-hidden="true"
      ></i>
    </button>
    <button
      type="button"
      class="btn-selection-powens"
      (click)="ouvrirSelectionComptesPowens()"
      [disabled]="chargementPowens() || chargementGestionPowens() || chargementSelectionPowens()"
      aria-label="Choisir les comptes et cartes Powens à importer"
      title="Choisir les comptes et cartes Powens"
      >
      <i
        class="ph-fill"
        [ngClass]="chargementSelectionPowens() ? 'ph-circle-notch icone-charge' : 'ph-list-checks'"
        aria-hidden="true"
      ></i>
    </button>
    <button type="button" class="btn-filtre-terminees" (click)="masquerTerminees.set(!masquerTerminees())">
      {{ masquerTerminees() ? '👁️ Afficher terminées' : '❌ Masquer terminées' }}
    </button>
    <button type="button" class="btn-filtre-terminees" (click)="masquerTermineesMoisCourant.set(!masquerTermineesMoisCourant())">
      {{ masquerTermineesMoisCourant() ? '👁️ Afficher pointées ce mois' : '✅ Masquer pointées ce mois' }}
    </button>
    <button type="button" class="btn-filtre-terminees" (click)="masquerMoisPasses.set(!masquerMoisPasses())">
      {{ masquerMoisPasses() ? '📅 Afficher mois passés' : '📅 Masquer mois passés' }}
    </button>
    @if (erreur()) {
      <span class="plan-annuel__erreur">{{ erreur() }}</span>
    }
  </div>

  <!-- Chargement -->
  @if (chargement()) {
    <div class="skeleton">Chargement…</div>
  }

  <!-- Contenu -->
  @if (!chargement() && tableau(); as t) {
    <div class="mobile-operations" aria-label="Liste des opérations du mois">
      @for (op of operationsMobile(); track (op.estReelle ? 'reelle-' : 'planifiee-') + op.id) {
        <article class="mobile-operation">
          <div class="mobile-operation__details">
            <div class="mobile-operation__label">
              <button type="button" class="mobile-action mobile-operation__edit" (click)="ouvrirEditionOp(op)"
                [attr.aria-label]="'Modifier ' + op.libelle" title="Modifier">
                <i class="ph ph-pencil-simple" aria-hidden="true"></i>
              </button>
              <h3>{{ op.libelle }}</h3>
            </div>
            <div class="mobile-operation__amounts" [class.montant-entree]="op.type === 'ENTREE'"
              [class.montant-sortie]="op.type === 'SORTIE'">
              @if (montantAPointerMobile(op) !== 0 || aOperationsEnAttenteMobile(op)) {
                <p>
                  @if (op.estReelle) {
                    <button type="button" class="mobile-action mobile-action--pointer mobile-operation__point-button"
                      (click)="pointerSansModif(op, moisCourantIdx())"
                      [attr.aria-label]="'Pointer ' + op.libelle" title="Pointer">
                      <i class="ph ph-check" aria-hidden="true"></i>
                    </button>
                  } @else {
                    <button type="button" class="mobile-action mobile-action--pointer mobile-operation__point-button"
                      (click)="ouvrirPointage(op, moisCourantIdx())"
                      [attr.aria-label]="'Pointer ' + op.libelle" title="Pointer">
                      <i class="ph ph-check-square" aria-hidden="true"></i>
                    </button>
                  }
                  <strong>{{ formatterMontant(montantAPointerMobile(op)) }}</strong>
                </p>
              }
              @if (montantPointeCeMois(op) !== 0) {
                <p>
                  <span class="mobile-operation__pointed" role="img" aria-label="Pointé" title="Pointé">
                    <i class="ph ph-check-circle" aria-hidden="true"></i>
                  </span>
                  <strong>{{ formatterMontant(montantPointeCeMois(op)) }}</strong>
                </p>
              }
            </div>
          </div>
          @if (montantPointeCeMois(op) !== 0) {
            <div class="mobile-operation__actions">
              @if (op.estReelle || op.provision) {
                <button type="button" class="mobile-action" (click)="ouvrirPointage(op, moisCourantIdx())"
                  [attr.aria-label]="'Voir ou dépointer les opérations de ' + op.libelle">
                  <i class="ph ph-arrow-counter-clockwise" aria-hidden="true"></i>Pointages
                </button>
              } @else {
                <button type="button" class="mobile-action" (click)="supprimerPointagesCeMois(op)"
                  [attr.aria-label]="'Dépointer ' + op.libelle">
                  <i class="ph ph-arrow-counter-clockwise" aria-hidden="true"></i>Dépointer
                </button>
              }
            </div>
          }
        </article>
      } @empty {
        <p class="mobile-operations__empty">
          {{ masquerPointeesMobile() ? 'Aucune opération à pointer ce mois-ci.' : 'Aucune opération ce mois-ci.' }}
        </p>
      }
    </div>
    @if (t.operations.length === 0) {
      <div class="plan-annuel__vide plan-annuel__vide--desktop">
        Aucune opération planifiée pour {{ annee() }}.
      </div>
    }
    @if (t.operations.length > 0) {
      <div class="table-wrapper">
        <table class="tableau tableau--annuel">
          <!-- ── En-têtes ─────────────────────────────────────────────────────── -->
          <thead>
            <tr>
              <th class="col-libelle col-sticky">Libellé</th>
              <th class="col-cat">Catégorie</th>
              <th class="col-jour" title="Jour du mois prévu">Jour</th>
              <th class="col-pointe" title="Montant pointé pour le mois en cours">Pointé</th>
              @for (item of moisAffichesAvecIdx(); track item) {
                <th
                  class="col-mois"
                  [class.col-mois--courant]="estMoisCourant(item.mois)"
                  [class.col-mois--passe]="estMoisPasse(item.mois)"
                  [class.col-mois--futur]="estMoisFutur(item.mois)"
                  [title]="estMoisCourant(item.mois) ? 'Mois en cours' : (estMoisPasse(item.mois) ? 'Opérations pointées — double-clic pour modifier' : 'Mois futur — double-clic pour modifier')"
                  >
                  {{ nomMois(item.mois) }}
                  @if (estMoisCourant(item.mois)) {
                    <span class="badge-courant">●</span>
                  }
                </th>
              }
              <th class="col-total">Total</th>
            </tr>
          </thead>
          <tbody>
            <!-- ════ ENTRÉES ════════════════════════════════════════════════════ -->
            <tr class="ligne-groupe ligne-groupe--entrees">
              <td class="col-libelle col-sticky col-groupe" [attr.colspan]="nombreMoisAffichesVue() + 5">
                ▲ Entrées
              </td>
            </tr>
            @for (op of entreesVisibles(); track trackById($index, op)) {
              <tr
                class="ligne-entree"
                [class.ligne-provision]="op.provision"
                [class.ligne-reelle]="op.estReelle"
                >
                <td class="col-libelle col-sticky">
                  <div class="libelle-wrapper">
                    <button type="button" class="btn-edit-ligne" title="Éditer" (click)="ouvrirEditionOp(op)">✏️</button>
                    <span>
                      @if (op.provision) {
                        <span class="badge-provision" title="Provision">P</span>
                      }
                      @if (op.estReelle) {
                        <span class="badge-reelle" title="Opération réelle">R</span>
                      }
                      @if (op.moyenPaiement === 'CB_DIFFERE') {
                        <i class="ph-fill ph-credit-card badge-cb-differe" title="CB différé" aria-hidden="true"></i>
                      }
                      {{ op.libelle }}
                      @if (echeanceCourante(op); as ech) {
                        <span class="cheque-numero">({{ ech.n }}/{{ ech.total }})</span>
                        @if (ech.numeroCheque) {
                          <span class="cheque-numero">(C{{ ech.numeroCheque }})</span>
                        }
                      }
                      @if (!echeanceCourante(op) && op.moyenPaiement === 'CHEQUE' && op.numeroCheque) {
                        <span class="cheque-numero">(C{{ op.numeroCheque }})</span>
                      }
                    </span>
                  </div>
                </td>
                <td class="col-cat">{{ op.categorie ?? '—' }}</td>
                <td class="col-jour">{{ op.jourDuMois }}</td>
                <td class="col-pointe" [class.montant-entree]="montantPointeCeMois(op) > 0">
                  @if (montantPointeCeMois(op) > 0) {
                    <span>{{ formatterMontant(montantPointeCeMois(op)) }}</span>
                    <button type="button" class="btn-depointer" title="Dépointer" (click)="supprimerPointagesCeMois(op); $event.stopPropagation()">
                      <i class="ph-fill ph-arrow-counter-clockwise" aria-hidden="true"></i>
                    </button>
                  }
                  @if (montantPointeCeMois(op) === 0) {
                    <span class="montant-inactif">—</span>
                  }
                </td>
                @for (item of moisAffichesAvecIdx(); track item) {
                  <td
                    class="col-mois"
                    [class.col-mois--courant]="estMoisCourant(item.mois)"
                    [class.col-mois--passe]="estMoisPasse(item.mois)"
                    [class.col-mois--futur]="estMoisFutur(item.mois)"
                    [class.col-mois--actif]="montantAffiche(op, item.idx) !== 0"
                    [class.col-mois--override]="!estMoisPasse(item.mois) && hasOverride(op, item.idx)"
                    >
                    <!-- Mode édition inline -->
                    @if (celluleEditeeKey() === celluleKey(op.id, item.idx)) {
                      <div class="cellule-edit">
                        <input
                          type="text" appMontant
                          min="0"
                          class="input-inline input-inline--montant"
                          [ngModel]="celluleMontantEdite()" [ngModelOptions]="{standalone: true}" required
                          (ngModelChange)="saisirMontantCellule($event)"
                          (keydown.enter)="sauvegarderCellule(op, item.idx)"
                          (keydown.escape)="annulerEditionCellule()"
                          autofocus
                          />
                        <div class="cellule-edit__actions">
                          <button type="button" class="btn-action btn-valider" title="Sauvegarder" (click)="sauvegarderCellule(op, item.idx)">✔</button>
                          <button type="button" class="btn-action btn-annuler" title="Annuler" (click)="annulerEditionCellule()">✕</button>
                          @if (hasOverride(op, item.idx)) {
                            <button
                              type="button"
                              class="btn-action btn-reset-override"
                              title="Restaurer valeur par défaut"
                              (click)="supprimerOverride(op, item.idx)"
                            >↺</button>
                          }
                        </div>
                      </div>
                    }
                    <!-- Mode affichage -->
                    @if (celluleEditeeKey() !== celluleKey(op.id, item.idx)) {
                      <div
                        class="cellule-montant"
                        [class.cellule-montant--editable]="celluleEditable(op, item.mois)"
                        (dblclick)="ouvrirEditionCellule(op, item.idx)"
                        >
                        @if (montantAffiche(op, item.idx) !== 0) {
                          <span
                            class="montant-entree"
                            >
                            {{ formatterMontant(montantAffiche(op, item.idx)) }}
                            @if (op.provision && estMoisCourant(item.mois)) {
                              <span class="provision-restante" title="Valeur restante sur la provision">restant</span>
                            }
                            @if (!estMoisPasse(item.mois) && hasOverride(op, item.idx)) {
                              <span class="override-indicator" title="Valeur personnalisée">*</span>
                            }
                          </span>
                        }
                        @if (!estMoisPasse(item.mois) && montantAffiche(op, item.idx) !== 0 && !op.estReelle && op.moyenPaiement === 'VIREMENT' && !(op.echeancesParMois[item.idx]?.virementProgramme ?? op.virementProgramme)) {
                          <i
                            class="ph-fill ph-warning warning-virement"
                            role="img" aria-label="Virement non programmé sur la banque"
                          title="Virement non programmé sur la banque"></i>
                        }
                        @if (montantAffiche(op, item.idx) === 0 && !(op.provision && estMoisCourant(item.mois))) {
                          <span class="montant-inactif">—</span>
                        }
                        @if (estMoisPasse(item.mois) && celluleEditable(op, item.mois)) {
                          <button
                            type="button" class="btn-pointer btn-pointer--edit btn-historique"
                            title="Voir et modifier les opérations du mois"
                            [attr.aria-label]="'Modifier les opérations de ' + op.libelle + ' — ' + nomMois(item.mois)"
                            (click)="ouvrirPointage(op, item.idx); $event.stopPropagation()">
                            <i class="ph-fill ph-pencil-simple" aria-hidden="true"></i>
                          </button>
                        }
                        <!-- Boutons d'action mois pointable -->
                        @if (estMoisPointable(item.mois) && !(estMoisPasse(item.mois) && celluleEditable(op, item.mois)) && (op.montantParMois[item.idx] !== 0 || op.provision)) {
                          <!-- Réelle -->
                          @if (op.estReelle) {
                            @if (hasUnpointedReellesCeMois(op, item.idx)) {
                              <button type="button" class="btn-pointer btn-pointer--pointer" title="Pointer" (click)="pointerSansModif(op, item.idx); $event.stopPropagation()">
                                <i class="ph-fill ph-check" aria-hidden="true"></i>
                              </button>
                            }
                            <button type="button" class="btn-pointer btn-pointer--edit" title="Éditer" (click)="ouvrirEditionOp(op); $event.stopPropagation()">
                              <i class="ph-fill ph-pencil-simple" aria-hidden="true"></i>
                            </button>
                          }
                          <!-- Provision -->
                          @if (op.provision && !op.estReelle) {
                            <button type="button" class="btn-pointer btn-pointer--utiliser" title="Utiliser (modifier le montant)" (click)="ouvrirPointage(op, item.idx); $event.stopPropagation()">
                              <i class="ph-fill ph-hand-withdraw" aria-hidden="true"></i>
                            </button>
                            <button type="button" class="btn-pointer btn-pointer--quick btn-pointer--disabled" title="Non disponible pour les provisions" disabled>
                              <i class="ph-fill ph-checks" aria-hidden="true"></i>
                            </button>
                          }
                          <!-- Planifiée normale -->
                          @if (!op.provision && !op.estReelle) {
                            <button type="button" class="btn-pointer btn-pointer--pointer" title="Pointer (modifier le montant)" (click)="ouvrirPointage(op, item.idx); $event.stopPropagation()">
                              <i class="ph-fill ph-check-square" aria-hidden="true"></i>
                            </button>
                            <button type="button" class="btn-pointer btn-pointer--quick" title="Pointer sans modification" (click)="pointerSansModif(op, item.idx); $event.stopPropagation()">
                              <i class="ph-fill ph-checks" aria-hidden="true"></i>
                            </button>
                          }
                        }
                      </div>
                    }
                  </td>
                }
                <td class="col-total montant-entree">
                  {{ formatterMontant(getTotal(op)) }}
                </td>
              </tr>
            }
            <!-- ════ SORTIES ════════════════════════════════════════════════════ -->
            <tr class="ligne-groupe ligne-groupe--sorties">
              <td class="col-libelle col-sticky col-groupe" [attr.colspan]="nombreMoisAffichesVue() + 5">
                ▼ Sorties
              </td>
            </tr>
            @for (op of sortiesVisibles(); track trackById($index, op)) {
              <tr
                class="ligne-sortie"
                [class.ligne-provision]="op.provision"
                [class.ligne-reelle]="op.estReelle"
                >
                <td class="col-libelle col-sticky">
                  <div class="libelle-wrapper">
                    <button type="button" class="btn-edit-ligne" title="Éditer" (click)="ouvrirEditionOp(op)">✏️</button>
                    <span>
                      @if (op.provision) {
                        <span class="badge-provision" title="Provision">P</span>
                      }
                      @if (op.estReelle) {
                        <span class="badge-reelle" title="Opération réelle">R</span>
                      }
                      @if (op.moyenPaiement === 'CB_DIFFERE') {
                        <i class="ph-fill ph-credit-card badge-cb-differe" title="CB différé" aria-hidden="true"></i>
                      }
                      {{ op.libelle }}
                      @if (echeanceCourante(op); as ech) {
                        <span class="cheque-numero">({{ ech.n }}/{{ ech.total }})</span>
                        @if (ech.numeroCheque) {
                          <span class="cheque-numero">(C{{ ech.numeroCheque }})</span>
                        }
                      }
                      @if (!echeanceCourante(op) && op.moyenPaiement === 'CHEQUE' && op.numeroCheque) {
                        <span class="cheque-numero">(C{{ op.numeroCheque }})</span>
                      }
                    </span>
                  </div>
                </td>
                <td class="col-cat">{{ op.categorie ?? '—' }}</td>
                <td class="col-jour">{{ op.jourDuMois }}</td>
                <td class="col-pointe" [class.montant-sortie]="montantPointeCeMois(op) > 0">
                  @if (montantPointeCeMois(op) > 0) {
                    <span>{{ formatterMontant(montantPointeCeMois(op)) }}</span>
                    <button type="button" class="btn-depointer" title="Dépointer" (click)="supprimerPointagesCeMois(op); $event.stopPropagation()">
                      <i class="ph-fill ph-arrow-counter-clockwise" aria-hidden="true"></i>
                    </button>
                  }
                  @if (montantPointeCeMois(op) === 0) {
                    <span class="montant-inactif">—</span>
                  }
                </td>
                @for (item of moisAffichesAvecIdx(); track item) {
                  <td
                    class="col-mois"
                    [class.col-mois--courant]="estMoisCourant(item.mois)"
                    [class.col-mois--passe]="estMoisPasse(item.mois)"
                    [class.col-mois--futur]="estMoisFutur(item.mois)"
                    [class.col-mois--actif]="montantAffiche(op, item.idx) !== 0"
                    [class.col-mois--override]="!estMoisPasse(item.mois) && hasOverride(op, item.idx)"
                    >
                    <!-- Mode édition inline -->
                    @if (celluleEditeeKey() === celluleKey(op.id, item.idx)) {
                      <div class="cellule-edit">
                        <input
                          type="text" appMontant
                          min="0"
                          class="input-inline input-inline--montant"
                          [ngModel]="celluleMontantEdite()" [ngModelOptions]="{standalone: true}" required
                          (ngModelChange)="saisirMontantCellule($event)"
                          (keydown.enter)="sauvegarderCellule(op, item.idx)"
                          (keydown.escape)="annulerEditionCellule()"
                          autofocus
                          />
                        <div class="cellule-edit__actions">
                          <button type="button" class="btn-action btn-valider" title="Sauvegarder" (click)="sauvegarderCellule(op, item.idx)">✔</button>
                          <button type="button" class="btn-action btn-annuler" title="Annuler" (click)="annulerEditionCellule()">✕</button>
                          @if (hasOverride(op, item.idx)) {
                            <button
                              type="button"
                              class="btn-action btn-reset-override"
                              title="Restaurer valeur par défaut"
                              (click)="supprimerOverride(op, item.idx)"
                            >↺</button>
                          }
                        </div>
                      </div>
                    }
                    <!-- Mode affichage -->
                    @if (celluleEditeeKey() !== celluleKey(op.id, item.idx)) {
                      <div
                        class="cellule-montant"
                        [class.cellule-montant--editable]="celluleEditable(op, item.mois)"
                        (dblclick)="ouvrirEditionCellule(op, item.idx)"
                        >
                        @if (montantAffiche(op, item.idx) !== 0) {
                          <span
                            class="montant-sortie"
                            >
                            {{ formatterMontant(montantAffiche(op, item.idx)) }}
                            @if (op.provision && estMoisCourant(item.mois)) {
                              <span class="provision-restante" title="Valeur restante sur la provision">restant</span>
                            }
                            @if (!estMoisPasse(item.mois) && hasOverride(op, item.idx)) {
                              <span class="override-indicator" title="Valeur personnalisée">*</span>
                            }
                          </span>
                        }
                        @if (!estMoisPasse(item.mois) && montantAffiche(op, item.idx) !== 0 && !op.estReelle && op.moyenPaiement === 'VIREMENT' && !(op.echeancesParMois[item.idx]?.virementProgramme ?? op.virementProgramme)) {
                          <i
                            class="ph-fill ph-warning warning-virement"
                            role="img" aria-label="Virement non programmé sur la banque"
                          title="Virement non programmé sur la banque"></i>
                        }
                        @if (montantAffiche(op, item.idx) === 0 && !(op.provision && estMoisCourant(item.mois))) {
                          <span class="montant-inactif">—</span>
                        }
                        @if (estMoisPasse(item.mois) && celluleEditable(op, item.mois)) {
                          <button
                            type="button" class="btn-pointer btn-pointer--edit btn-historique"
                            title="Voir et modifier les opérations du mois"
                            [attr.aria-label]="'Modifier les opérations de ' + op.libelle + ' — ' + nomMois(item.mois)"
                            (click)="ouvrirPointage(op, item.idx); $event.stopPropagation()">
                            <i class="ph-fill ph-pencil-simple" aria-hidden="true"></i>
                          </button>
                        }
                        <!-- Boutons d'action mois pointable -->
                        @if (estMoisPointable(item.mois) && !(estMoisPasse(item.mois) && celluleEditable(op, item.mois)) && (op.montantParMois[item.idx] !== 0 || op.provision)) {
                          <!-- Réelle -->
                          @if (op.estReelle) {
                            @if (hasUnpointedReellesCeMois(op, item.idx)) {
                              <button type="button" class="btn-pointer btn-pointer--pointer" title="Pointer" (click)="pointerSansModif(op, item.idx); $event.stopPropagation()">
                                <i class="ph-fill ph-check" aria-hidden="true"></i>
                              </button>
                            }
                            <button type="button" class="btn-pointer btn-pointer--edit" title="Éditer" (click)="ouvrirEditionOp(op); $event.stopPropagation()">
                              <i class="ph-fill ph-pencil-simple" aria-hidden="true"></i>
                            </button>
                          }
                          <!-- Provision -->
                          @if (op.provision && !op.estReelle) {
                            <button type="button" class="btn-pointer btn-pointer--utiliser" title="Utiliser (modifier le montant)" (click)="ouvrirPointage(op, item.idx); $event.stopPropagation()">
                              <i class="ph-fill ph-hand-withdraw" aria-hidden="true"></i>
                            </button>
                            <button type="button" class="btn-pointer btn-pointer--quick btn-pointer--disabled" title="Non disponible pour les provisions" disabled>
                              <i class="ph-fill ph-checks" aria-hidden="true"></i>
                            </button>
                          }
                          <!-- Planifiée normale -->
                          @if (!op.provision && !op.estReelle) {
                            <button type="button" class="btn-pointer btn-pointer--pointer" title="Pointer (modifier le montant)" (click)="ouvrirPointage(op, item.idx); $event.stopPropagation()">
                              <i class="ph-fill ph-check-square" aria-hidden="true"></i>
                            </button>
                            <button type="button" class="btn-pointer btn-pointer--quick" title="Pointer sans modification" (click)="pointerSansModif(op, item.idx); $event.stopPropagation()">
                              <i class="ph-fill ph-checks" aria-hidden="true"></i>
                            </button>
                          }
                        }
                      </div>
                    }
                  </td>
                }
                <td class="col-total montant-sortie">
                  {{ formatterMontant(getTotal(op)) }}
                </td>
              </tr>
            }
          </tbody>
          <!-- ── Totaux ─────────────────────────────────────────────────────── -->
          <tfoot>
            <tr class="ligne-total ligne-total--entrees">
              <td class="col-libelle col-sticky" colspan="3">Total Entrées</td>
              <td class="col-pointe montant-entree">
                @if (totalPointeCeMoisEntrees() > 0) {
                  <span>{{ formatterMontant(totalPointeCeMoisEntrees()) }}</span>
                }
                @if (totalPointeCeMoisEntrees() === 0) {
                  <span class="montant-inactif">—</span>
                }
              </td>
              @for (item of moisAffichesAvecIdx(); track item) {
                <td
                  class="col-mois montant-entree"
                  >
                  @if (totauxParMois()[item.idx].entrees > 0) {
                    <span>{{ formatterMontant(totauxParMois()[item.idx].entrees) }}</span>
                  }
                  @if (totauxParMois()[item.idx].entrees === 0) {
                    <span class="montant-inactif">—</span>
                  }
                </td>
              }
              <td class="col-total montant-entree">{{ formatterMontant(totalAnneeEntrees()) }}</td>
            </tr>
            <tr class="ligne-total ligne-total--sorties">
              <td class="col-libelle col-sticky" colspan="3">Total Sorties</td>
              <td class="col-pointe montant-sortie">
                @if (totalPointeCeMoisSorties() > 0) {
                  <span>{{ formatterMontant(totalPointeCeMoisSorties()) }}</span>
                }
                @if (totalPointeCeMoisSorties() === 0) {
                  <span class="montant-inactif">—</span>
                }
              </td>
              @for (item of moisAffichesAvecIdx(); track item) {
                <td
                  class="col-mois montant-sortie"
                  >
                  @if (totauxParMois()[item.idx].sorties > 0) {
                    <span>{{ formatterMontant(totauxParMois()[item.idx].sorties) }}</span>
                  }
                  @if (totauxParMois()[item.idx].sorties === 0) {
                    <span class="montant-inactif">—</span>
                  }
                </td>
              }
              <td class="col-total montant-sortie">{{ formatterMontant(totalAnneeSorties()) }}</td>
            </tr>
            <tr class="ligne-total ligne-total--solde">
              <td class="col-libelle col-sticky" colspan="3">Solde net mensuel</td>
              <td class="col-pointe"
                [class.montant-entree]="totalPointeCeMoisEntrees() >= totalPointeCeMoisSorties()"
                [class.montant-sortie]="totalPointeCeMoisEntrees() < totalPointeCeMoisSorties()">
                {{ formatterMontant(totalPointeCeMoisEntrees() - totalPointeCeMoisSorties()) }}
              </td>
              @for (item of moisAffichesAvecIdx(); track item) {
                <td
                  class="col-mois"
                  [class.montant-entree]="totauxParMois()[item.idx].solde >= 0"
                  [class.montant-sortie]="totauxParMois()[item.idx].solde < 0"
                  >
                  {{ formatterMontant(totauxParMois()[item.idx].solde) }}
                </td>
              }
              <td
                class="col-total"
                [class.montant-entree]="totalAnneeSolde() >= 0"
                [class.montant-sortie]="totalAnneeSolde() < 0"
                >
                {{ formatterMontant(totalAnneeSolde()) }}
              </td>
            </tr>
            <tr class="ligne-total ligne-total--solde-cumule">
              <td class="col-libelle col-sticky" colspan="3">Solde cumulé</td>
              <td class="col-pointe"
                [class.montant-entree]="soldeDispo() !== null && soldeDispo()! >= 0"
                [class.montant-sortie]="soldeDispo() !== null && soldeDispo()! < 0"
                [title]="'Solde compte + Solde carte différé'"
                >
                {{ soldeDispo() !== null ? formatterMontant(soldeDispo()!) : '' }}
              </td>
              @for (item of moisAffichesAvecIdx(); track item) {
                <td
                  class="col-mois"
                  [class.montant-entree]="soldesCumules()[item.idx] >= 0"
                  [class.montant-sortie]="soldesCumules()[item.idx] < 0"
                  >
                  {{ formatterMontant(soldesCumules()[item.idx]) }}
                </td>
              }
              <td
                class="col-total"
                [class.montant-entree]="soldesCumules()[soldesCumules().length - 1] >= 0"
                [class.montant-sortie]="soldesCumules()[soldesCumules().length - 1] < 0"
                >
                {{ formatterMontant(soldesCumules()[soldesCumules().length - 1] || 0) }}
              </td>
            </tr>
            <tr class="ligne-total ligne-total--solde-cumule-sans-cb">
              <td class="col-libelle col-sticky" colspan="3">Solde cumulé sans CB différé</td>
              <td class="col-pointe"
                [class.montant-entree]="soldeSansCBDifferee() !== null && soldeSansCBDifferee()! >= 0"
                [class.montant-sortie]="soldeSansCBDifferee() !== null && soldeSansCBDifferee()! < 0"
                [title]="'Solde compte, sans le règlement de la carte différée'"
                >
                {{ soldeSansCBDifferee() !== null ? formatterMontant(soldeSansCBDifferee()!) : '' }}
              </td>
              @for (item of moisAffichesAvecIdx(); track item) {
                <td
                  class="col-mois"
                  [class.montant-entree]="soldesCumulesSansCBDifferee()[item.idx] >= 0"
                  [class.montant-sortie]="soldesCumulesSansCBDifferee()[item.idx] < 0"
                  >
                  {{ formatterMontant(soldesCumulesSansCBDifferee()[item.idx]) }}
                </td>
              }
              <td
                class="col-total"
                [class.montant-entree]="soldesCumulesSansCBDifferee()[soldesCumulesSansCBDifferee().length - 1] >= 0"
                [class.montant-sortie]="soldesCumulesSansCBDifferee()[soldesCumulesSansCBDifferee().length - 1] < 0"
                >
                {{ formatterMontant(soldesCumulesSansCBDifferee()[soldesCumulesSansCBDifferee().length - 1] || 0) }}
              </td>
            </tr>
            <tr class="ligne-total ligne-total--cb-differe">
              <td class="col-libelle col-sticky" colspan="3">Total CB différé</td>
              <td class="col-pointe"
                [class.montant-sortie]="totalPointeCeMoisCBDifferee() > 0"
                [class.montant-entree]="totalPointeCeMoisCBDifferee() < 0"
                >
                @if (totalPointeCeMoisCBDifferee() !== 0) {
                  <span>{{ formatterMontant(totalPointeCeMoisCBDifferee()) }}</span>
                }
                @if (totalPointeCeMoisCBDifferee() === 0) {
                  <span class="montant-inactif">—</span>
                }
              </td>
              @for (item of moisAffichesAvecIdx(); track item) {
                <td
                  class="col-mois"
                  [class.montant-sortie]="totauxCBDiffereParMois()[item.idx] > 0"
                  [class.montant-entree]="totauxCBDiffereParMois()[item.idx] < 0"
                  >
                  @if (totauxCBDiffereParMois()[item.idx] !== 0) {
                    <span>{{ formatterMontant(totauxCBDiffereParMois()[item.idx]) }}</span>
                  }
                  @if (totauxCBDiffereParMois()[item.idx] === 0) {
                    <span class="montant-inactif">—</span>
                  }
                </td>
              }
              <td class="col-total"
                [class.montant-sortie]="totalAnneeCBDiffere() > 0"
                [class.montant-entree]="totalAnneeCBDiffere() < 0"
              >{{ formatterMontant(totalAnneeCBDiffere()) }}</td>
            </tr>
            <tr class="ligne-total ligne-total--passage-negatif">
              <td class="col-libelle col-sticky" colspan="3">Passage en négatif</td>
              <td class="col-pointe">—</td>
              @for (item of moisAffichesAvecIdx(); track item) {
                <td
                  class="col-mois"
                  [title]="joursPassageNegatif()[item.idx] !== null ? 'Jour du passage en négatif' : 'Pas de passage en négatif prévu'"
                  >
                  {{ joursPassageNegatif()[item.idx] ?? '—' }}
                </td>
              }
              <td class="col-total">—</td>
            </tr>
          </tfoot>
        </table>
      </div>
    }
  }

  <!-- ── Panel de pointage ─────────────────────────────────────────────────── -->
  <app-popup-pointage-planifiee
    [operation]="editionOp() ? null : (pointageData()?.op ?? null)"
    [montantInitial]="montantInitialPointage()"
    [libellePeriode]="libellePeriodePointage()"
    [editionAutorisee]="true"
    [historiqueUniquement]="pointageData()?.op?.estReelle ?? false"
    (editerOperation)="ouvrirEditionOperationReelle($event)"
    [operationsReelles]="operationsReellesPourPointage()"
    [totalReelles]="totalReellesPourPointage()"
    [operationsNonPointees]="operationsNonPointeesPourPointage()"
    [enregistrement]="enregistrementProvision()"
    [erreur]="erreur()"
    [moyensPaiement]="moyensPaiement"
    [comptesDisponibles]="comptesDisponibles"
    (ajouterNonPointee)="onAjouterOperationProvision($event)"
    (pointerOperation)="onPointerOperationProvision($event)"
    (reporterOperation)="onReporterOperationProvision($event)"
    (supprimerOperation)="onSupprimerOperationProvision($event)"
    (confirmer)="onConfirmerPointage($event)"
    (annuler)="annulerPointage()"
    (depointerOperation)="onDepointerOperation($event)"
  ></app-popup-pointage-planifiee>

  <!-- ── Popup import presse-papier ───────────────────────────────────────── -->
  <app-popup-import-planifiee
    [visible]="!!importLignes()"
    [source]="importSource()"
    [lignes]="importLignes() ?? []"
    [toutesLignes]="importToutesLignes() ?? []"
    [operations]="tableau()?.operations ?? []"
    [tableauMois]="tableau()?.mois ?? []"
    (confirmer)="onConfirmerImport($event)"
    (annuler)="importLignes.set(null); importToutesLignes.set(null)"
  ></app-popup-import-planifiee>

  <!-- ── Sélection des comptes Powens ─────────────────────────────────────── -->
  <app-popup-selection-powens
    [visible]="selectionPowensVisible()"
    [comptes]="comptesSelectionPowens()"
    [comptePrincipalId]="comptePrincipalSelectionPowensId()"
    [comptesCarteIds]="comptesCarteSelectionPowensIds()"
    [chargement]="chargementSelectionPowens() || chargementGestionPowens()"
    [erreur]="erreurSelectionPowens()"
    (confirmer)="enregistrerSelectionComptesPowens($event)"
    (annuler)="fermerSelectionComptesPowens()"
    (gererDansPowens)="gererComptesPowens()"
  ></app-popup-selection-powens>

  <!-- ── Panel édition opération ──────────────────────────────────────────── -->

  <!-- Édition opération planifiée (composant partagé) -->
  <app-popup-edition-planifiee
    [operation]="!editionOp()?.estReelle ? editionOp() : null"
    [visible]="!!editionOp() && !editionOp()!.estReelle"
    [erreur]="erreur()"
    [categories]="categories"
    [moyensPaiement]="moyensPaiement"
    [comptesDisponibles]="comptesDisponibles"
    [groupeIds]="editionOp()?.groupeIds ?? null"
    (sauvegarder)="onSauvegarderEditionPlanifiee($event)"
    (annuler)="annulerEditionOp()"
    (supprimer)="onSupprimerEditionPlanifiee($event)"
    (supprimerGroupe)="supprimerOpGroupe()"
    (ajouterCategorie)="ajouterCategorie.emit()"
  ></app-popup-edition-planifiee>

  <!-- Édition opération réelle (formulaire inline) -->
  @if (editionOp()?.estReelle) {
    <div class="canvas-pointage canvas-operation-reelle">
      <div class="canvas-pointage__overlay" (click)="annulerEditionOp()"></div>
      <div class="canvas-pointage__panel canvas-operation-reelle__panel" role="dialog" aria-modal="true">
        <div class="canvas-operation-reelle__header">
          <div>
            <p class="canvas-operation-reelle__eyebrow">Edition</p>
            <h3>Modifier l'opération réelle</h3>
          </div>
          <button type="button" class="canvas-operation-reelle__close" aria-label="Fermer" (click)="annulerEditionOp()">
            &times;
          </button>
        </div>
        <form class="formulaire canvas-operation-reelle__form" (ngSubmit)="sauvegarderEditionOp()">
          @if (erreur()) {
            <p class="canvas-operation-reelle__erreur" role="alert">{{ erreur() }}</p>
          }
          <section class="canvas-operation-reelle__section">
            <div class="canvas-operation-reelle__section-header">
              <div>
                <h4>Informations générales</h4>
                <p>Libellé, type et montant</p>
              </div>
            </div>
            <div class="canvas-operation-reelle__grid">
              <label class="canvas-operation-reelle__field canvas-operation-reelle__field--full">
                Libellé
                <input type="text" [value]="editionForm().libelle"
                  (input)="updateEditionForm('libelle', $any($event.target).value)" autofocus />
              </label>
              <label class="canvas-operation-reelle__field">
                Type
                <select [value]="editionForm().type"
                  (change)="updateEditionForm('type', $any($event.target).value)">
                  <option value="ENTREE">Entrée</option>
                  <option value="SORTIE">Sortie</option>
                </select>
              </label>
              <label class="canvas-operation-reelle__field">
                Montant
                <input type="text" appMontant [ngModel]="editionForm().montant" [ngModelOptions]="{standalone: true}" required
                  (ngModelChange)="updateEditionForm('montant', $event)" />
              </label>
              <label class="canvas-operation-reelle__field">
                Catégorie
                <input type="text" [value]="editionForm().categorie"
                  (input)="updateEditionForm('categorie', $any($event.target).value)" placeholder="Optionnel" />
              </label>
            </div>
          </section>
          <!-- Section opération réelle -->
          <section class="canvas-operation-reelle__section">
            <div class="canvas-operation-reelle__section-header">
              <div><h4>Date de l'opération</h4></div>
            </div>
            <div class="canvas-operation-reelle__grid">
              <label class="canvas-operation-reelle__field">
                Date
                <input type="date" [value]="editionForm().dateOperation"
                  (input)="updateEditionForm('dateOperation', $any($event.target).value)" />
              </label>
              <label class="canvas-operation-reelle__field canvas-operation-reelle__field--moyen">
                Moyen de paiement
                <select [value]="editionForm().moyenPaiement ?? ''"
                  (change)="updateEditionForm('moyenPaiement', $any($event.target).value || null)">
                  <option value="">Aucun</option>
                  @for (m of moyensPaiement; track m) {
                    <option [value]="m.value">{{ m.label }}</option>
                  }
                </select>
              </label>
              @if (editionForm().moyenPaiement === 'CHEQUE') {
                <label class="canvas-operation-reelle__field">
                  Numéro de chèque
                  <input type="text" name="numeroCheque" aria-required="true" [value]="editionForm().numeroCheque"
                    (input)="updateEditionForm('numeroCheque', $any($event.target).value)" />
                </label>
              }
            </div>
          </section>
          <!-- Section opération planifiée (non rendue pour réelles) -->
          @if (false) {
            <section class="canvas-operation-reelle__section">
              <div class="canvas-operation-reelle__section-header">
                <div>
                  <h4>Calendrier &amp; répétition</h4>
                  <p>Durée, jour d'exécution et options</p>
                </div>
              </div>
              <div class="canvas-operation-reelle__grid">
                <label class="canvas-operation-reelle__field">
                  Jour du mois
                  <input type="number" min="1" max="31" [value]="editionForm().jourDuMois"
                    (input)="updateEditionForm('jourDuMois', +$any($event.target).value)" />
                </label>
                @if (!editionOp()?.provision) {
                  <label class="canvas-operation-reelle__field">
                    Date début
                    <input type="date" [value]="editionForm().dateDebut"
                      (input)="updateEditionForm('dateDebut', $any($event.target).value)" />
                  </label>
                }
                <label class="canvas-operation-reelle__field">
                  Nombre de mois
                  <input type="number" min="1" [value]="editionForm().nombreDeMois"
                    (input)="updateEditionForm('nombreDeMois', $any($event.target).value === '' ? '' : +$any($event.target).value)"
                    placeholder="Illimité" />
                </label>
                <label class="canvas-operation-reelle__field canvas-operation-reelle__field--checkbox">
                  <span>Étalement</span>
                  <div class="checkbox">
                    <input type="checkbox" [checked]="editionForm().estEtalee"
                      (change)="updateEditionForm('estEtalee', $any($event.target).checked)" />
                    Étaler la dépense
                  </div>
                </label>
                @if (!editionOp()?.provision) {
                  <label class="canvas-operation-reelle__field canvas-operation-reelle__field--checkbox">
                    <span>Provision</span>
                    <div class="checkbox">
                      <input type="checkbox" [checked]="editionForm().provision"
                        (change)="updateEditionForm('provision', $any($event.target).checked)" />
                      Activer la provision
                    </div>
                  </label>
                }
              </div>
            </section>
          }
          @if (false) {
            <section class="canvas-operation-reelle__section">
              <div class="canvas-operation-reelle__section-header">
                <div><h4>Moyen de paiement</h4></div>
              </div>
              <div class="canvas-operation-reelle__grid">
                <label class="canvas-operation-reelle__field canvas-operation-reelle__field--moyen">
                  Moyen de paiement
                  <select [value]="editionForm().moyenPaiement ?? ''"
                    (change)="updateEditionForm('moyenPaiement', $any($event.target).value || null)">
                    <option value="">Aucun</option>
                    @for (m of moyensPaiement; track m) {
                      <option [value]="m.value">{{ m.label }}</option>
                    }
                  </select>
                </label>
              </div>
            </section>
          }
          <div class="form-actions canvas-operation-reelle__actions">
            <button type="submit">Sauvegarder</button>
            <button type="button" class="btn-secondaire" (click)="annulerEditionOp()">Annuler</button>
          </div>
          <div class="form-actions" style="margin-top: 0.5rem;">
            @if (confirmSupprId() !== editionOp()?.id) {
              <button type="button" class="btn-supprimer" (click)="demanderConfirmSuppression()">🗑 Supprimer</button>
            }
            @if (confirmSupprId() === editionOp()?.id) {
              <span class="confirm-suppr">Confirmer la suppression ?</span>
              <button type="button" class="btn-confirmer-suppr" (click)="supprimerOp()">Oui, supprimer</button>
              @if (editionOp()?.groupeRef || (editionOp()?.groupeIds?.length ?? 0) > 1) {
                <button type="button" class="btn-confirmer-suppr btn-confirmer-suppr--groupe"
                  (click)="supprimerOpGroupe()"
                  title="Supprimer toutes les occurrences de cette mensualisation">
                  Supprimer toute la mensualisation
                </button>
              }
              <button type="button" class="btn-secondaire" (click)="annulerSuppression()">Annuler</button>
            }
          </div>
        </form>
      </div>
    </div>
  }

</div>

<app-popup-recherche-operation
  [visible]="rechercheVisible()"
  [compteId]="compte?.id ?? null"
  [comptes]="comptesDisponibles"
  [categories]="categories"
  [moyensPaiement]="moyensPaiement"
  (fermer)="rechercheVisible.set(false)"
></app-popup-recherche-operation>
